// The actor rig — the small, fixed vocabulary of part names an *actor* (a
// character that engages a model at a {@link Station}) exposes for an
// {@link Interaction} to drive. It is the contract that makes interactions
// actor-agnostic: any actor model whose parts carry these names can play any
// interaction, the way any keyboard fits any typist. An interaction's
// `subject: "actor"` track may only target a name in this set; `defineModel`
// enforces it with a teaching error.

/** The whole-actor node — moving, rotating or scaling the actor as one (its
 *  root transform, not a geometry part), so it is always available even on an
 *  actor that names no limbs. A station's lean/lift/turn drives this. */
export const ACTOR_ROOT = "root";

/** Every name a `subject: "actor"` track may target. `root` is the whole actor;
 *  the rest are optional limbs an actor model may name to become posable. */
export const ACTOR_RIG = [
  ACTOR_ROOT,
  "body",
  "head",
  "arm-l",
  "arm-r",
  "leg-l",
  "leg-r",
] as const;

/** A name an interaction's actor track may target. */
export type ActorRigPart = (typeof ACTOR_RIG)[number];

/** Is `name` a valid actor-rig target? */
export function isRigPart(name: string): name is ActorRigPart {
  return (ACTOR_RIG as readonly string[]).includes(name);
}
